import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

export default function SimpleSnackbar(props) {
  const [state, setState] = React.useState({
    open: false,
    message: ''
  });

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setState({
      ...state,
      open: false
    });
  };

  props.listeners.onSuccess = () => setState({
    open: true,
    message: 'This app is ready to be used offline!'
  });;

  return (
    <div>
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        open={state.open}
        autoHideDuration={6000}
        onClose={handleClose}
        message={state.message}
        action={
          <IconButton size='small' aria-label='close' color='inherit' onClick={handleClose}>
            <CloseIcon fontSize='small' />
          </IconButton>
        }
      />
    </div>
  );
}
